import React from 'react'
import SectionHeader from '../../components/SectionHeader'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { BsShop } from 'react-icons/bs'
import { IoIosFootball } from 'react-icons/io'
import { FaBaseballBall, FaBasketballBall, FaBowlingBall, FaHockeyPuck } from 'react-icons/fa'

const SportsServices = () => {
    return (
        <>
            <section>
                <SectionHeader title="Sports Services" PageLink="Sports  Services Page"></SectionHeader>
                <div className="inner-page-container pb-5">
                    <div className="about-section top__about">
                        <Container>
                            <div className="sports-services-pages">
                                <Row className='justify-content-center gy-4' style={{ width: "100%" }}>
                                    <Col md={3} lg={3}>
                                        <Link to="/service/baseball-insurance-usa" className="services_card">
                                            <div className="services_icon">
                                                <FaBaseballBall />
                                            </div>
                                            <div className="services__content__box">
                                                <p><strong>Baseball Insurance USA</strong></p>
                                                <p className="services__content__box_vendor">
                                                    <span> Play Ball, We’ve Got Your Back</span>
                                                    <br />
                                                    Baseball may be America’s pastime, but twisted ankles, line drives, and rain delays are nobody’s favorite memories. That’s why our baseball insurance USA plans are here to cover the curveballs life throws at your game.
                                                </p>
                                                <Link to="/service/baseball-insurance-usa" className='learn-more'>learn More</Link>
                                            </div>
                                        </Link>
                                    </Col>

                                    <Col md={3} lg={3}>
                                        <Link to="/service/basketball-insurance-usa" className="services_card">
                                            <div className="services_icon">
                                                <FaBasketballBall />
                                            </div>
                                            <div className="services__content__box">
                                                <p><strong>Basketball Insurance USA </strong></p>
                                                <p className="services__content__box_vendor">
                                                    <span>Keep the Game Going, Even When Life Fools You </span>
                                                    <br />
                                                    Basketball is fast, fun, and full of energy. But let’s be honest, a slick floor or a stray elbow can change the game in a heartbeat. Our basketball insurance USA makes sure accidents don’t keep you off the court.
                                                </p>
                                                <Link to="/service/basketball-insurance-usa" className='learn-more'>learn More</Link>
                                            </div>
                                        </Link>
                                    </Col>

                                    <Col md={3} lg={3}>
                                        <Link to="/service/bowling-insurance-usa" className="services_card">
                                            <div className="services_icon">
                                                <FaBowlingBall />
                                            </div>
                                            <div className="services__content__box">
                                                <p><strong>Bowling Insurance USA </strong></p>
                                                <p className="services__content__box_vendor">
                                                    <span> Roll Strikes, Not Risks </span>
                                                    <br />
                                                    Bowling is supposed to be fun strikes, spares, and maybe a little friendly trash talk. But slips on the lane or dropped bowling balls happen more often than you think. That’s why our bowling insurance USA keeps alleys, leagues, and teams protected.
                                                </p>
                                                <Link to="/service/bowling-insurance-usa" className='learn-more'>learn More</Link>
                                            </div>
                                        </Link>
                                    </Col>

                                    <Col md={3} lg={3}>
                                        <Link to="/service/kickball-insurance-usa" className="services_card">
                                            <div className="services_icon">
                                                <IoIosFootball />
                                            </div>
                                            <div className="services__content__box">
                                                <p><strong>Kickball Insurance USA </strong></p>
                                                <p className="services__content__box_vendor">
                                                    <span> Keep the Fun Alive, Even When Someone Trips Over Third Base </span>
                                                    <br />
                                                    Kickball is pure joy. Adults get to feel like kids again, kids get to burn off energy, and everyone gets to laugh. But laughter doesn’t pay for injuries. Our kickball insurance USA makes sure accidents don’t kick your season to the curb.
                                                </p>
                                                <Link to="/service/kickball-insurance-usa" className='learn-more'>learn More</Link>
                                            </div>
                                        </Link>
                                    </Col>

                                    <Col md={3} lg={3}>
                                        <Link to="/service/hockey-insurance-usa" className="services_card">
                                            <div className="services_icon">
                                                <FaHockeyPuck />
                                            </div>
                                            <div className="services__content__box">
                                                <p><strong>Hockey Insurance USA</strong></p>
                                                <p className="services__content__box_vendor">
                                                    <span>Stronger Protection Than a Goalie’s Pads </span>
                                                    <br />
                                                    Hockey is fast, rough, and thrilling. Between the flying pucks, big hits, and slippery ice, accidents are almost part of the game. Our hockey insurance USA makes sure your league, team, or tournament doesn’t get left out in the cold.
                                                </p>
                                                <Link to="/service/hockey-insurance-usa" className='learn-more'>learn More</Link>
                                            </div>
                                        </Link>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SportsServices